/**
 * Mixin for custom elements that appends a template into the shadowRoot from
 * the static `template` property.
 */
const UsingTemplate = (superclass) => {
  return class extends superclass {
    constructor() {
      super();
      if ((!this.constructor.template) instanceof DocumentFragment) {
        throw new Error(`Missing template for ${this.tagName}`);
      }
      this.attachShadow({ mode: "open" });
      this.shadowRoot.append(this.constructor.template.cloneNode(true));
    }
  };
};

export { UsingTemplate };
